module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<h1>Print Joinos Letters</h1>\n';
 if(mode == "done"){ 
__p+='\n<div class="processing done">\n    <img src="/static/icons/tick.svg" class="picon" /><br/>\n    Your letters are being produced. We will email you once they have\n    finished processing.\n</div>\n<a class="button">\n    Close\n</a>\n';
 } else { 
__p+='\n<div class="processing">\n    <img src="/static/icons/cog.svg" class="cogicon" /><br/>\n    One moment please...\n</div>\n';
 } 
__p+='\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./joinos_codes/templates/print_submitted.html
// module id = 308
// module chunks = 0